export default __webpack_public_path__ + "static/media/bulk-transaction.5b9f8fe9.png";